import {
	ArticleDimensionsContext,
	createArticleDimensions,
} from "@components/Layouts/CatalogLayout/ArticleLayout/useArticleDimensions";
import { WidthWrapperDisabledProvider } from "@components/WidthWrapper/WidthWrapper";
import { cn } from "@core-ui/utils/cn";
import type { ViewSettings } from "@ext/markdown/elements/view/models/ViewSettings";
import View from "@ext/markdown/elements/view/render/components/View";
import { Display } from "@ext/properties/models/display";
import { PanelLoader } from "@ui-kit/FloatingPanel";
import { useLayoutEffect, useMemo, useRef } from "react";

const STRETCH_VIEW_WRAPPERS = cn(
	"[&_[data-component=view]]:flex [&_[data-component=view]]:min-h-0 [&_[data-component=view]]:flex-1 [&_[data-component=view]]:flex-col",
	"[&_.block-comment-view]:flex [&_.block-comment-view]:min-h-0 [&_.block-comment-view]:flex-1 [&_.block-comment-view]:flex-col",
);

const REPORT_SCALE = "text-sm";

interface CatalogReportContentProps {
	settings: ViewSettings;
	updateArticle: (articlePath: string, property: string, value: string, isDelete?: boolean) => void;
}

export const CatalogReportContent = ({ settings, updateArticle }: CatalogReportContentProps) => {
	const dimensions = useMemo(() => createArticleDimensions(), []);
	const contentRef = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		if (!contentRef.current) return;
		return dimensions.observe(contentRef.current, dimensions.setWidth);
	}, [dimensions]);

	const useArticleStyles = settings.display !== Display.Table;

	return (
		<ArticleDimensionsContext.Provider value={dimensions}>
			<div
				className={cn("flex min-h-0 flex-1 flex-col px-3 pb-3", REPORT_SCALE, useArticleStyles && "article")}
				ref={contentRef}
			>
				<div
					className={cn(
						"flex min-h-0 flex-1 flex-col",
						useArticleStyles
							? "article-body overflow-y-auto overflow-x-hidden"
							: cn("overflow-hidden", STRETCH_VIEW_WRAPPERS),
					)}
				>
					<WidthWrapperDisabledProvider>
						<View {...settings} disabled={false} loading={<PanelLoader />} updateArticle={updateArticle} />
					</WidthWrapperDisabledProvider>
				</div>
			</div>
		</ArticleDimensionsContext.Provider>
	);
};
